export class MaterialForReplacementToElement {
  article: string;
  materialId: number;
  materialName: string;
  price: number;
  textureName: string;
  cropTextureLink: string;
  textureLink: string;
  color: string;
}
